import { Tab } from '@headlessui/react'
import { Link } from '@remix-run/react'
import clsx from 'clsx'
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '#app/components/ui/accordion'
import { Button } from '#app/components/ui/button.tsx'

import backgroundImage from '../images/background-features.jpg'
import whatIsColours from '../images/coloursexplosion/whatis.jpg'
import screenshotProfitLoss from '../images/screenshots/profit-loss.png'
import breakfastMenu from './images/breakfast2.png'
import drinksMenu from './images/drinks.png'
import foodMenu from './images/food.png'
import glow from './images/glow.png'
import paint from './images/paint.png'
import photo1 from './images/photo1.jpg'
import photo2 from './images/photo2.jpg'
import photo3 from './images/photo3.jpg'
import photo4 from './images/photo4.jpg'
import photo5 from './images/photo5.jpg'
import photo6 from './images/photo6.jpg'
import powder from './images/powder.png'
import premium from './images/premium.png'
import uknownReveal from './images/unknown.jpg'

export default function IndexRoute() {
	return (
		<>
			<div className="m-1 flex items-center justify-center pt-6">
				<Hero />
			</div>
			<main className="mx-auto max-w-7xl">
				<WhatIs />
				<WhatsOn />
				<TicketsIndex />
				<Features />
				<Faqs />
			</main>
		</>
	)
}

function Hero() {
	return (
		<>
			<div className="text-center align-middle">
				<h1 className="font-display mx-auto max-w-4xl text-5xl font-medium tracking-tight text-white sm:text-7xl">
					Saturday{' '}
					<span className="relative whitespace-nowrap text-blue-600">
						<svg
							aria-hidden="true"
							viewBox="0 0 418 42"
							className="absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70"
							preserveAspectRatio="none"
						>
							<path d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z" />
						</svg>
						<span className="relative">15th June 2024.</span>
					</span>{' '}
					Colours Explosion is back!
				</h1>
				<p className="mx-auto mt-2 max-w-2xl text-lg tracking-tight">
					Reserve tickets soon!
				</p>
				<div className="mt-3 flex justify-center gap-x-4">
					<div>
						<dl className="grid grid-cols-2 gap-x-6 gap-y-2 sm:mt-16 sm:gap-x-16 sm:gap-y-10 sm:text-center lg:auto-cols-auto lg:grid-flow-col lg:grid-cols-none lg:justify-start lg:text-left">
							<div>
								<dt className="font-mono text-sm text-blue-600">Start Time</dt>
								<dd className="mt-0.5 text-2xl font-semibold tracking-tight text-blue-400">
									10:00 pm
								</dd>
							</div>
							<div>
								<dt className="font-mono text-sm text-blue-600">Location</dt>
								<dd className="mt-0.5 text-2xl font-semibold tracking-tight text-blue-400">
									Marian, St. George
								</dd>
							</div>
							<div>
								<dt className="font-mono text-sm text-blue-600">Venue</dt>
								<dd className="mt-0.5 text-2xl font-semibold tracking-tight text-blue-400">
									The Marian Playing Field
								</dd>
							</div>
						</dl>
						<div className="my-6">
							<Link to="#" target="_blank" rel="noreferrer">
								<Button variant="outline" className="bg-white">
									<svg
										aria-hidden="true"
										className="h-3 w-3 flex-none fill-gray-900"
									>
										<path d="m9.997 6.91-7.583 3.447A1 1 0 0 1 1 9.447V2.553a1 1 0 0 1 1.414-.91L9.997 5.09c.782.355.782 1.465 0 1.82Z" />
									</svg>
									<span className="ml-3 text-gray-900">
										Promo video coming soon!
									</span>
								</Button>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

function WhatIs() {
	const whatis = [
		{
			id: 1,
			title:
				'Colours Explosion is back, hitting the Marian Playing Field on Sat, June 15th, with a lineup of live artists, DJs, and feters! Come show Grenada how to party for Spicemas 24!',
			description:
				'Join feters at Colours Explosion to experience spectacular live performances, unforgettable entertainment, and more! Event details will be release late May 2024. Follow us to be the first to get Colours Explosion info!',
			imageUrl: whatIsColours,
		},
	]
	return (
		<div id="whatis" aria-label="What is Colours Explosion?">
			<div className="mx-auto">
				{whatis.map(post => (
					<article key={post.id} className="flex flex-col lg:flex-row">
						<div className="p-6 pt-0 lg:w-1/2">
							<h2 className="text-xl font-bold leading-tight tracking-tight text-white">
								{post.title}
							</h2>
							<p className="mt-2 text-base leading-tight">{post.description}</p>
						</div>
						<div className="m-2 mt-0 border-2 border-indigo-600 lg:w-1/2">
							<img
								src={post.imageUrl}
								alt=""
								className="inset-0 h-full w-full bg-gray-50 object-cover"
							/>
						</div>
					</article>
				))}
			</div>
		</div>
	)
}

function WhatsOn() {
	const whatson = [
		{
			title: 'Live Artists',
			description:
				"See live performances by some of Grenada's top soca artists",
			names: [

				{
					id: 1,
					name: '',
					href: '#',
					imageSrc: uknownReveal,
					imageAlt: 'Hidden Artist 1.',
				},
				{
					id: 2,
					name: '',
					href: '#',
					imageSrc: uknownReveal,
					imageAlt: 'Hidden Artist 2.',
				},
				{
					id: 3,
					name: '',
					href: '#',
					imageSrc: uknownReveal,
					imageAlt: 'Hidden Artist 3.',
				},
			],
		},
		{
			title: 'Host and DJs',
			description: "Entertainment by some of Grenada's top DJs, MCs and hosts",
			names: [
				{
					id: 1,
					name: '',
					href: '#',
					imageSrc: uknownReveal,
					imageAlt: 'Hand stitched, orange leather long wallet.',
				},
				{
					id: 2,
					name: '',
					href: '#',
					imageSrc: uknownReveal,
					imageAlt: 'Hand stitched, orange leather long wallet.',
				},
				{
					id: 3,
					name: '',
					href: '#',
					imageSrc: uknownReveal,
					imageAlt: 'Hand stitched, orange leather long wallet.',
				},
			],
		},
		{
			title: 'Plus More',
			description:
				'Paint, powder, and more attactions during Colours Explosion',
			names: [
				{
					id: 1,
					name: '',
					href: '#',
					imageSrc: paint,
					imageAlt: 'Hand stitched, orange leather long wallet.',
				},
				{
					id: 2,
					name: '',
					href: '#',
					imageSrc: powder,
					imageAlt: 'Hand stitched, orange leather long wallet.',
				},
				{
					id: 3,
					name: '',
					href: '#',
					imageSrc: glow,
					imageAlt: 'Hand stitched, orange leather long wallet.',
				},
			],
		},
	]

	return (
		<section
			id="whatson"
			aria-label="What's on at Colours Explosion?"
			className="relative overflow-hidden bg-blue-600 p-2"
		>
			<img
				className="absolute left-1/2 top-1/2 max-w-none translate-x-[-44%] translate-y-[-42%]"
				src={backgroundImage}
				alt=""
				width={2245}
				height={1636}
			/>
			<div className="relative">
				<div className="max-w-2xl px-6 md:mx-auto md:text-center xl:max-w-none">
					<h2 className="font-display animate-gradient bg-[linear-gradient(to_right,theme(colors.indigo.400),theme(colors.indigo.100),theme(colors.sky.400),theme(colors.fuchsia.400),theme(colors.sky.400),theme(colors.indigo.100),theme(colors.indigo.400))]  bg-[length:200%_auto] bg-clip-text text-3xl font-bold tracking-tight text-transparent sm:text-4xl">
						What's On
					</h2>
					<p className="mt-2 text-base leading-tight tracking-tight text-blue-100">
						Get ready to see hear some of Grenada's top artists and DJs explode
						the Marian Playing Field! Check out some of the entertainment you'll
						experience.
					</p>
				</div>

				<Tab.Group
					as="div"
					className="mt-2 grid items-center gap-y-2 pt-2 sm:gap-y-6 lg:pt-0"
				>
					{({ selectedIndex }) => (
						<>
							<div className="-mx-4 flex overflow-x-auto pb-4 sm:mx-0 sm:overflow-visible sm:pb-0 ">
								<Tab.List className="relative z-10 flex gap-x-1 whitespace-nowrap px-4 sm:mx-auto sm:px-0 lg:mx-0 lg:gap-x-0 lg:gap-y-1 lg:whitespace-normal">
									{whatson.map((whatson, whatsonIndex) => (
										<div
											key={whatson.title}
											className={clsx(
												'group relative rounded-full px-4 py-1 lg:rounded-l-xl lg:rounded-r-none lg:p-6',
												selectedIndex === whatsonIndex
													? 'bg-white lg:bg-white/10 lg:ring-1 lg:ring-inset lg:ring-white/10'
													: 'hover:bg-white/10 lg:hover:bg-white/5',
											)}
										>
											<h3>
												<Tab
													className={clsx(
														'font-display ui-not-focus-visible:outline-none text-lg',
														selectedIndex === whatsonIndex
															? 'text-blue-600 lg:text-white'
															: 'text-blue-100 hover:text-white lg:text-white',
													)}
												>
													<span className="absolute inset-0 rounded-full lg:rounded-l-xl lg:rounded-r-none" />
													{whatson.title}
												</Tab>
											</h3>
											<p
												className={clsx(
													'mt-2 hidden text-sm lg:block',
													selectedIndex === whatsonIndex
														? 'text-white'
														: 'text-blue-100 group-hover:text-white',
												)}
											>
												{whatson.description}
											</p>
										</div>
									))}
								</Tab.List>
							</div>
							<Tab.Panels>
								{whatson.map(whatson => (
									<Tab.Panel key={whatson.title} unmount={false}>
										<div className="relative sm:px-6 lg:hidden">
											<div className="absolute" />
											<p className="relative mx-auto max-w-2xl px-6 text-base leading-tight text-white sm:text-center">
												{whatson.description}
											</p>
										</div>
										<div className=" sm:w-auto lg:mt-0">
											<div className="mx-auto">
												<div className="mt-2 grid w-full grid-cols-3 gap-x-2 gap-y-2 sm:gap-x-2 md:gap-y-0 lg:grid-cols-3 lg:gap-x-2">
													{whatson.names.map(name => (
														<div key={name.name}>
															<img
																className="mx-auto h-36 w-36 rounded-lg lg:h-72 lg:w-72"
																src={name.imageSrc}
																alt=""
															/>
															<h3 className="mb-2 text-center text-base font-semibold leading-7 tracking-tight text-white md:mb-4">
																{name.name}
															</h3>
														</div>
													))}
												</div>
											</div>
										</div>
									</Tab.Panel>
								))}
							</Tab.Panels>
						</>
					)}
				</Tab.Group>
			</div>
		</section>
	)
}

function TicketsIndex() {
	return (
		<div className="py-6">
			<div className="mx-auto max-w-7xl px-6 lg:px-8">
				<div className="mx-auto max-w-2xl sm:text-center">
					<h2 className="animate-gradient bg-[linear-gradient(to_right,theme(colors.green.300),theme(colors.green.100),theme(colors.sky.400),theme(colors.yellow.200),theme(colors.sky.400),theme(colors.green.100),theme(colors.green.300))] bg-[length:200%_auto] bg-clip-text text-3xl font-extrabold tracking-tight text-transparent sm:text-4xl">
						Tickets Pricing
					</h2>

					<p className="text-lg">
						Tickets include Regular, Customized and Premium Experiences.
					</p>
				</div>

				<div className="grid md:grid-cols-2 md:gap-16">
					<div>
						<div className="mx-auto mt-2 max-w-2xl rounded-3xl ring-1 ring-rose-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
							<div className="p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
								<div className="rounded-2xl text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
									<p className="text-3xl font-semibold text-rose-500">
										Regular Experience
									</p>
									<div className="mx-auto max-w-xs px-8">
										<p className="text-base font-semibold ">
											Basic entry into Colours Explosion
										</p>
										<p className="flex items-baseline justify-center gap-x-2">
											<span className="text-5xl font-bold tracking-tight ">
												$40
											</span>
											<span className="0 text-sm font-semibold leading-6 tracking-wide">
												XCD
											</span>
										</p>
										<Link
											to="#"
											className="mt-2 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold  shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
										>
											Reserve Tickets Soon
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className="mx-auto mt-5 max-w-2xl rounded-3xl ring-1 ring-fuchsia-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none ">
							<div className="p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
								<div className="rounded-2xl text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
									<p className="text-3xl font-semibold text-fuchsia-500">
										Ultra Experience
									</p>
									<div className="mx-auto max-w-xs px-8">
										<p className="text-base font-semibold ">
											Reserve the entire experience. Includes all products and
											services offered in the Custom Experience.
										</p>
										<p className="flex items-baseline justify-center gap-x-2">
											<span className="text-5xl font-bold tracking-tight ">
												$250
											</span>
											<span className="text-sm font-semibold leading-6 tracking-wide ">
												XCD
											</span>
										</p>
										<Link
											to="#"
											className="mt-2 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
										>
											Reserve Tickets Soon
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

interface Feature {
	name: React.ReactNode
	summary: string
	image: string
	icon: React.ComponentType
}

const features = [
	{
		name: 'Photos',
		summary: 'Relive Colours Explosion in photos!',
		images: [
			{
				id: 1,
				name: '',
				price: '',
				href: '#',
				imageSrc: photo1,
				imageAlt: 'Colours Explosion Photo 1.',
			},
			{
				id: 2,
				name: '',
				price: '',
				href: '#',
				imageSrc: photo2,
				imageAlt: 'Colours Explosion Photo 2.',
			},
			{
				id: 3,
				name: '',
				price: '',
				href: '#',
				imageSrc: photo3,
				imageAlt: 'Colours Explosion Photo 3.',
			},
			{
				id: 4,
				name: '',
				price: '',
				href: '#',
				imageSrc: photo4,
				imageAlt: 'Colours Explosion Photo 4.',
			},
			{
				id: 5,
				name: '',
				price: '',
				href: '#',
				imageSrc: photo5,
				imageAlt: 'Colours Explosion Photo 5.',
			},
			{
				id: 6,
				name: '',
				price: '',
				href: '#',
				imageSrc: photo6,
				imageAlt: 'Colours Explosion Photo 6.',
			},
		],
		icon: function PhotosIcon() {
			return (
				<>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="h-6 w-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
						/>
					</svg>
				</>
			)
		},
	},
	{
		name: 'Services',
		summary: 'Here are some of the services offered during Colours Explosion!',
		images: [
			{
				id: 1,
				price: '',
				href: '#',
				imageSrc: drinksMenu,
				imageAlt: 'Hand stitched, orange leather long wallet.',
			},
			{
				id: 2,
				price: '',
				href: '#',
				imageSrc: foodMenu,
				imageAlt: 'Hand stitched, orange leather long wallet.',
			},
			{
				id: 3,
				price: '',
				href: '#',
				imageSrc: breakfastMenu,
				imageAlt: 'Hand stitched, orange leather long wallet.',
			},
			{
				id: 4,
				href: '#',
				imageSrc: premium,
				imageAlt: 'Hand stitched, orange leather long wallet.',
			},
		],
		icon: function ServicesIcon() {
			return (
				<>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="h-6 w-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
						/>
					</svg>
				</>
			)
		},
	},
]

function Features() {
	return (
		<section
			id="features"
			aria-label="Features for simplifying everyday business tasks"
			className="p-6 pt-0 lg:mt-6"
		>
			<div>
				<div className="mx-auto max-w-2xl md:text-center">
					<h2 className="font-display animate-gradient bg-[linear-gradient(to_right,theme(colors.indigo.400),theme(colors.indigo.100),theme(colors.sky.400),theme(colors.fuchsia.400),theme(colors.sky.400),theme(colors.indigo.100),theme(colors.indigo.400))]  bg-[length:200%_auto] bg-clip-text text-3xl font-bold leading-tight tracking-tight text-transparent">
						The Experience of Colours
					</h2>

					<p className="mt-1 text-lg leading-tight tracking-tight">
						Relive Colours Explosion in pictures and get ready by checking out
						our merchandises and services offered!
					</p>
				</div>
				<FeaturesMobile />
				<FeaturesDesktop />
			</div>
		</section>
	)
}

function Feature({
	feature,
	isActive,
	className,
	...props
}: React.ComponentPropsWithoutRef<'div'> & {
	feature: Feature
	isActive: boolean
}) {
	return (
		<div
			className={clsx(className, !isActive && 'opacity-75 hover:opacity-100')}
			{...props}
		>
			<div className="flex flex-row">
				<div
					className={clsx(
						'w-9 rounded-lg',
						isActive ? 'bg-indigo-600' : 'bg-slate-500',
					)}
				>
					<svg aria-hidden="true" className="h-9 w-9" fill="none">
						<feature.icon />
					</svg>
				</div>
				<h3
					className={clsx(
						'p-1 text-xl font-medium',
						isActive ? 'text-indigo-600' : 'text-white',
					)}
				>
					{feature.name}
				</h3>
			</div>
		</div>
	)
}

function FeaturesMobile() {
	return (
		<div className="mt-2 flex flex-col overflow-hidden md:gap-y-10  lg:hidden">
			{features.map(feature => (
				<div key={feature.summary}>
					<Feature feature={feature} className="mx-auto max-w-2xl" isActive />
					<div className="mx-auto max-w-2xl px-2 py-2 lg:max-w-7xl lg:px-8">
						<div className="grid grid-cols-2 gap-x-3 gap-y-3 md:grid-cols-3 xl:gap-x-8">
							{feature.images.map(name => (
								<a key={name.id} href={name.href} className="group">
									<div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg sm:aspect-h-3 sm:aspect-w-2">
										<img
											src={name.imageSrc}
											alt={name.imageAlt}
											className="h-full w-full object-cover object-center group-hover:opacity-75"
										/>
									</div>
								</a>
							))}
						</div>
					</div>
				</div>
			))}
		</div>
	)
}

function FeaturesDesktop() {
	return (
		<Tab.Group as="div" className="hidden lg:mt-6 lg:block">
			{({ selectedIndex }) => (
				<>
					<Tab.List className="grid grid-cols-2 gap-x-2">
						{features.map((feature, featureIndex) => (
							<Feature
								key={feature.summary}
								feature={{
									...feature,
									name: (
										<Tab className="ui-not-focus-visible:outline-none">
											<span className="absolute inset-0" />
											{feature.name}
										</Tab>
									),
								}}
								isActive={featureIndex === selectedIndex}
								className="relative"
							/>
						))}
					</Tab.List>
					<Tab.Panels>
						{features.map(feature => (
							<Tab.Panel key={feature.name} unmount={false}>
								<div className="relative sm:px-6 lg:hidden">
									<div className="absolute" />
									<p className="relative mx-auto max-w-2xl text-base  sm:text-center">
										{feature.summary}
									</p>
								</div>
								<div className=" sm:w-auto lg:mt-0">
									<div className="mx-auto">
										<div className="mx-auto max-w-2xl px-4 py-2 lg:max-w-7xl lg:px-8">
											<div className="mt-6 grid grid-cols-4 gap-x-6 gap-y-10 xl:gap-x-8">
												{feature.images.map(name => (
													<div key={name.id} className="group relative">
														<div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-md  lg:aspect-none group-hover:opacity-75 lg:h-80">
															<img
																src={name.imageSrc}
																alt={name.imageAlt}
																className="h-full w-full object-cover object-center lg:h-full lg:w-full"
															/>
														</div>
													</div>
												))}
											</div>
										</div>
									</div>
								</div>
							</Tab.Panel>
						))}
					</Tab.Panels>
				</>
			)}
		</Tab.Group>
	)
}

function Faqs() {
	const faqs = [
		{
			id: 1,
			question: 'Where is the Marian Playing FIeld located?',
			answer:
				'The two closest known points to the Marian Playing Field are Cocoa Road and the entrance to Hope Vale. Marian, is located near Morne Jaloux.',
		},
		{
			id: 2,
			question: 'Where can I purchase advanced tickets?',
			answer:
				'You can purchase advanced tickets online, or by contacting a Feel Free Promotions team member.',
		},
		{
			id: 3,
			question: 'What will the ticket price the day of the event?',
			answer: 'Tickets at the gate are expected to increase by about 15%',
		},
		{
			id: 4,
			question: 'Is vending allowed at Colours Explosion?',
			answer: 'NO! You are not allowed to vend near or in Colours Explosion.',
		},
	]
	return (
		<section
			id="faq"
			aria-labelledby="faq-title"
			className="relative overflow-hidden p-2"
		>
			<div className="relative px-4 mx-auto lg:px-8">
				<div className="mx-auto max-w-2xl lg:mx-0">
					<h2
						id="faq-title"
						className="font-display animate-gradient bg-[linear-gradient(to_right,theme(colors.purple.400),theme(colors.purple.100),theme(colors.pink.300),theme(colors.orange.400),theme(colors.pink.300),theme(colors.purple.100),theme(colors.purple.400))] bg-[length:200%_auto] bg-clip-text text-3xl font-bold tracking-tight text-transparent sm:text-4xl md:text-center"
					>
						Your Colours Explosion Questions, Answered
					</h2>
				</div>

				<div className="mx-auto max-w-6xl">
					<ul className="grid grid-cols-1 gap-2 lg:max-w-none lg:grid-cols-2">
						{faqs.map(faq => (
							<li key={faq.id}>
								<Accordion type="single" collapsible>
									<AccordionItem value={`item-${faq.id}`}>
										<AccordionTrigger>
											<p className="text-left font-serif text-lg">
												{faq.question}
											</p>
										</AccordionTrigger>
										<AccordionContent>{faq.answer}</AccordionContent>
									</AccordionItem>
								</Accordion>
							</li>
						))}
					</ul>
				</div>
			</div>
		</section>
	)
}
